import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "lib/apiInstance";
import { LOCAL_STORAGE } from "utils/constant";
import { BASE_URL, EndpointsSlug } from "./endpoints";

export const topupService = createApi({
  reducerPath: "topupService",
  baseQuery: baseQueryWithReauth({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem(LOCAL_STORAGE.USER_TOKEN) || "";
      headers.set("Content-type", "application/json; charset=UTF-8");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  tagTypes: ["topup_request", "user_list"],
  endpoints: (builder) => ({
    getTopupRequests: builder.query({
      query: (params) => ({
        url: EndpointsSlug.GET_ALL_TOPUPS,
        method: "GET",
        params,
      }),
      providesTags: ["topup_request"],
    }),
    approveTopupRequest: builder.mutation({
      query: ({ requestId, approvedCoins, adminNote }) => ({
        url: `${EndpointsSlug.APPROVE_TOPUP}/${requestId}`,
        method: "POST",
        body: { approvedCoins, adminNote },
      }),
      invalidatesTags: ["topup_request", "user_list"],
    }),
    rejectTopupRequest: builder.mutation({
      query: ({ requestId, adminNote }) => ({
        url: `${EndpointsSlug.REJECT_TOPUP}/${requestId}`,
        method: "POST",
        body: { adminNote },
      }),
      invalidatesTags: ["topup_request"],
    }),
  }),
});

export const {
  useGetTopupRequestsQuery,
  useApproveTopupRequestMutation,
  useRejectTopupRequestMutation,
} = topupService;
